import { ActivityLog } from '@models';

export interface SecurityActivityLogResult {
  rootSecurityActivityLogs: ActivityLog[];
}
